import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { BASE_URL } from '@/utils/constants/apiEndpoints';

export interface UpdateEriTrackingDto {
  deviceId: string;
  isEriTracked: boolean;
}

export const updateEriTrackingApiSlice = createApi({
  reducerPath: 'updateEriTrackingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    }
  }),
  tagTypes: ['UpdateEriTracking'],
  endpoints: (builder) => ({
    updateEriTracking: builder.mutation<void, UpdateEriTrackingDto>({
      query: ({ deviceId, isEriTracked }) => ({
        url: '/devices/update-eri-tracking',
        method: 'POST',
        body: {
          deviceId,
          isEriTracked
        }
      })
    })
  })
});

export const { useUpdateEriTrackingMutation } = updateEriTrackingApiSlice;
